import { Box, Typography } from '@mui/material';
import React, { useCallback } from 'react';

import { ROUTING_CONFIG } from '@uplift/constants';
import { useL10n, useQueryString } from '@uplift/hooks';

import { checkResetPasswordToken } from '@uplift/api';
import { Loader } from '@uplift/ui-v2';
import { useQuery } from '@tanstack/react-query';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { SetPasswordForm } from './components';


export const SetPasswordPage = ({ redirectUrl = ROUTING_CONFIG.login }) => {
  const { push } = useHistory();
  const l10n = useL10n();

  const setPasswordHandler = useCallback(() => {
    push(redirectUrl);
  }, [ redirectUrl ]); // eslint-disable-line react-hooks/exhaustive-deps

  const location = useLocation();
  const params = useQueryString(location.search);
  const resetPasswordToken = React.useMemo(() => {
    if (Array.isArray(params?.token)) {
      return params?.token[0];
    }
    return params?.token;
  }, [ params?.token ]);

  const { data: resetPasswordTokenCheck, isLoading: isResetPasswordTokenCheckLoading } = useQuery([ 'password-token', resetPasswordToken ], async () => {
    return await checkResetPasswordToken({ reset_password_token: resetPasswordToken });
  }, { retry: 1 });

  if (isResetPasswordTokenCheckLoading) {
    return <Loader />;
  }

  if (resetPasswordTokenCheck?.status !== 'valid') {
    return (
      <Box display="flex" flexDirection="column" flexGrow={1} alignItems="center" justifyContent="center">
        <Typography align="center" variant="h4">Sorry! This link is no longer valid</Typography>
        <Box mt={2}>
          <Typography align="center" variant="body1">Please try using the <Link to={ROUTING_CONFIG.resetPassword}>forgot password</Link> link again</Typography>
        </Box>
      </Box>
    );
  }

  return (
    <>
      <Box mt={5} />
      <Typography sx={{ mb: 4 }} variant="h2" align="center">{l10n.auth.reset}</Typography>
      <SetPasswordForm onSubmit={setPasswordHandler} />
    </>
  );
};
